import { IconButton } from "@mui/material";
import { useAtomValue, useSetAtom } from "jotai";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { Menu } from "../../../styles/icons/menu";
import { sidebarOpenAtom, toggleSidebarAtom } from "../../layout/components/sidebar/store";
import { layoutAtom } from "../../layout/components/store";

export const HeaderBarBurger: FC = () => {
  const { t } = useTranslation();

  const layout = useAtomValue(layoutAtom);
  const toggleSidebar = useSetAtom(toggleSidebarAtom);
  const sidebarOpen = useAtomValue(sidebarOpenAtom);

  return (
    <IconButton
      data-analytics-id="sidebar-open"
      sx={(theme) => ({
        color: layout === "default" ? theme.palette.text.primary : "var(--ah-text-color)",
        boxShadow: sidebarOpen
          ? `0 0 5px 5px ${theme.palette.text.primary}aa`
          : `0 0 0 0  ${theme.palette.text.primary}00`,
        transition: "box-shadow 2s ease-out",
      })}
      onClick={toggleSidebar}
      title={t("Open main nav")}
    >
      <Menu />
    </IconButton>
  );
};
